/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Availableslots_Placeholder1Inputs */

const en_job_form_availableslots_placeholder1 = /** @type {(inputs: Job_Form_Availableslots_Placeholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. 3`)
};

const de_job_form_availableslots_placeholder1 = /** @type {(inputs: Job_Form_Availableslots_Placeholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z. B. 3`)
};

/**
* | output |
* | --- |
* | "e.g. 3" |
*
* @param {Job_Form_Availableslots_Placeholder1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_availableslots_placeholder1 = /** @type {((inputs?: Job_Form_Availableslots_Placeholder1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Availableslots_Placeholder1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_availableslots_placeholder1(inputs)
	return en_job_form_availableslots_placeholder1(inputs)
});
export { job_form_availableslots_placeholder1 as "job_form_availableSlots_placeholder" }